/** API RELATION enum values */
export const RELATION_OPTIONS = [
  { value: '', label: 'Select relation' },
  { value: 'FATHER', label: 'Father' },
  { value: 'MOTHER', label: 'Mother' },
  { value: 'BROTHER', label: 'Brother' },
  { value: 'SISTER', label: 'Sister' },
  { value: 'FRIEND', label: 'Friend' },
  { value: 'SPOUSE', label: 'Spouse' },
  { value: 'SON', label: 'Son' },
  { value: 'DAUGHTER', label: 'Daughter' },
  { value: 'OTHER', label: 'Other' },
] as const;
